<template>
  <div>
    <stockwarehouse
      :warehouses="warehouses"
      :locationnetworks="locationNetworks"
      :locationnodes="locationNodes"
      @warehouseChange="getWarehouses()"
      :tableloading="tableLoading"
    ></stockwarehouse>
  </div>
</template>

<script>
import Api from "@/services/Api";
import StockWarehouse from "@/components/StockWarehouse.vue";

export default {
  components: {
    stockwarehouse: StockWarehouse
  },
  data() {
    return {
      tableLoading: true,
      warehouses: [],
      locationNetworks: [],
      locationNodes: [],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
        this.getWarehouses();
        this.getLocationNetworks();
        this.getLocationNodes();
      
    },
    getWarehouses() {
      Api()
        .get("/stockWarehouse")
        .then(response => {
          this.warehouses = response.data;
          this.tableLoading=false
        });
    },
    getLocationNetworks() {
      Api()
        .get("/locationNetworks")
        .then(response => {
          this.locationNetworks = response.data;
          this.tableLoading=false
        });
    },
    getLocationNodes() {
      Api()
        .get("/locationNodes")
        .then(response => {
          this.locationNodes = response.data;
          this.tableLoading=false
        });
    }
  }
};
</script>

<style>
</style>